import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Form, Modal } from "react-bootstrap";
import { useForm, useWatch } from "react-hook-form";
import axios from "axios";
import { ConfirmationAlert, getOnlyToken } from "../utils/commonFunctions";
import AudioWavePlayer from "./AudioPlayer";



export default function Ivr() {
  const [search, setSearch] = useState("");
  const [ivrdata, setIvrData] = useState([])
  const [loading, setLoading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [activeTab, setActiveTab] = useState('ivr');
  const [showModal, setShowModal] = useState(false);
  const [audioList, setAudioList] = useState([]);
  const [companies,setCompanies]= useState([])
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [audioCurrentPage, setAudioCurrentPage] = useState(1);
  const [audioPerPage, setAudioPerPage] = useState(10);
  const [audioTotalCount, setAudioTotalCount] = useState(0);
  const navigate = useNavigate()
  const {
    register: registerAudio,
    control: controlAudio,
    handleSubmit: handleSubmitAudio,
    reset: resetAudio,
    setValue: setValueAudio,
    formState: { errors: errorsAudio },
  } = useForm();
  const [voices, setVoices] = useState([])
  const selectedGender = useWatch({ control: controlAudio, name: "gender" });
  const selectedAudio = useWatch({ control: controlAudio, name: "audioFile" });
  const watchedLanguage = useWatch({ control: controlAudio, name: "language" });

  const location = useLocation();
  const token = getOnlyToken();


  useEffect(() => {
    if (location.state?.openModal) {
      setActiveTab('audio')
      setShowModal(true);
    }
  }, [location.state]);
  useEffect(() => {
    fetchIVRs()
    fetchAudios()
    fetchCompanies()
  }, [])

  useEffect(() => {
    setValueAudio("voice", "");
    if (watchedLanguage && selectedGender) {
      fetchVoices(watchedLanguage, selectedGender);
    }
  }, [watchedLanguage, selectedGender]);



  const fetchCompanies = async ()=>{
    try {
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const res = await axios.get('api/agents/folder/create/',config)
      if(res.status === 200){
        setCompanies(res.data.folders)
      }
    } catch (error) {
      console.error('Failed to fetch agents for folder', error);
      setCompanies([]);
    }
  }


  const fetchIVRs = async (pageNum = 1, pageSize = 10) => {
    setLoading(true);
    try {
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const res = await axios.get(`/ivr/ivr-config/dropdown/?pagenumber=${pageNum}&perpage=${pageSize}`, config);
       const pagination = res.data.pagination || {};
      if (res.status === 200) {
        setIvrData(res.data.data);
        setCurrentPage(pagination.current_page || pageNum);
        setPerPage(pagination.per_page || pageSize);
        setTotalCount(pagination.total_count || 0);
      }
    } catch (error) {
      setErrorMessage(error.response?.data?.message || "Failed to fetch IVRs");
      setShowErrorModal(true);
    } finally {
      setLoading(false);
    }
  }

   const handlePageChange = (page) => {
        fetchIVRs(page, perPage);
    };

    const handlePerPageChange = (newPerPage) => {
        setPerPage(newPerPage);
        fetchIVRs(1, newPerPage);
    };

    const handleAudioPageChange = (page) => {
        fetchAudios(page, audioPerPage);
    };

    const handleAudioPerPageChange = (newPerPage) => {
        setAudioPerPage(newPerPage);
        fetchAudios(1, newPerPage);
    };

  const handleDeleteClick = (ivr) => {
    ConfirmationAlert(
      `Are you sure you want to delete "${ivr.ivr_name}"!`,
      'Yes, delete it!',
      () => handleDeleteConfirm(ivr.id)
    );
  }

  
  const handleDeleteAudio = (aud) => {
    ConfirmationAlert(
      `Are you sure you want to delete "${aud.filename}"!`,
      'Yes, delete it!',
      () => handleDeleteConfirm(aud.id)
    );
  }

  const handleDeleteConfirm = async (ivrID) => {
    setLoading(true);
    try {
      const config = { headers: { Authorization: `Bearer ${token}` } };
      await axios.delete(`/ivr/ivr_config/${ivrID}/delete/`, config);
      await fetchIVRs(currentPage, perPage);
      setSuccessMessage("IVR deleted successfully");
      setShowSuccessModal(true);
    } catch (error) {
      setErrorMessage(error.response?.data?.message || "Failed to delete workflow");
      setShowErrorModal(true);
    } finally {
      setLoading(false);
    }
  }



  const fetchVoices = async (languageCode, gender) => {
    try {
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const payload = {
        language_code: languageCode,
        gender: gender.toLowerCase()
      };

      console.log('Fetching voices with payload:', payload);
      console.log('API URL:', `${process.env.REACT_APP_API_BASE_URL2}/tts/voices`);

      const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL2}/tts/voices`, payload, config);

      if (res.status === 200) {
        console.log('Voices fetched:', res.data.voices);
        setVoices(res.data.voices || []);
      }
    } catch (error) {
      console.error('Error fetching voices:', error.response?.data || error.message);
      setVoices([]);
    }
  }


  /* ================= AUDIO SAVE ================= */
  const handleAudioSave = handleSubmitAudio(async (data) => {
    try {
      setLoading(true);
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const payload = {
        text: data.description,
        // companyId: data.company,
        filename: data.audioName,
        language_code: data.language,
        voice_name: data.voice
      };

      console.log('Creating audio with payload:', payload);

      const res = await axios.post('/ivr/ivr-audio/generate/', payload, config);

      if (res.status === 200 || res.status === 201) {
        await fetchAudios(1, audioPerPage);
        setSuccessMessage('Audio created successfully!');
        setShowSuccessModal(true);
        resetAudio();
        setShowModal(false);
      }
    } catch (error) {
      console.error('Error creating audio:', error);
      setErrorMessage(error.response?.data?.message || 'Failed to create audio');
      setShowErrorModal(true);
    } finally {
      setLoading(false);
    }
  });

  const fetchAudios = async (pageNum = 1, pageSize = 10) => {
    try {
      setLoading(true);

      const config = { headers: { Authorization: `Bearer ${token}` } };

      const res = await axios.get(`ivr/ivr-audios/?pagenumber=${pageNum}&perpage=${pageSize}`, config)
      const pagination = res.data.pagination || {};

      if (res.status === 200) {
        setAudioList(res.data.data || res.data);
        setAudioCurrentPage(pagination.current_page || pageNum);
        setAudioPerPage(pagination.per_page || pageSize);
        setAudioTotalCount(pagination.total_count || 0);
        console.log(res.data, 'audiolist');

      }
    } catch (error) {
      console.log(error, 'errror')
    } finally {
      setLoading(false);

    }
  }


  const audioColumns = [
    { name: 'S.NO', width: '80px', selector: (row, index) => index + 1 },
    { name: "Audio Name", center: true, selector: (row) => row.filename },
    { name: "Language", center: true, selector: (row) => row.language_code },
    {
      name: "Preview",
      center: true,
      wrap: true,
      allowOverflow: false,
      cell: (row) => (
        <div
          className="d-flex align-items-center gap-4 mt-1"
          style={{
            maxWidth: "280px",
            overflow: "hidden",
          }}
        >
          {/* Audio Player */}
          <AudioWavePlayer key={row.audio_path} src={row.audio_path} />

          {/* Download Icon */}
          <a
            href={row.audio_path}
            download
            title="Download Audio"
            style={{
              color: "#0dd359ff",
              fontSize: "18px",
              cursor: "pointer",
              textDecoration: "none",
              flexShrink: 0,
              marginBottom: '20px',
            }}
          >
            <i className="bi bi-download"></i>
          </a>
        </div>
      ),
    }
    ,

    {
      name: "Actions",
      width: "120px",
      center: true,
      allowOverflow: false,
      cell: (row) => (
        <div className="d-flex justify-content-center">
          <button
            className="btn border-danger btn-sm d-flex align-items-center justify-content-center"
            style={{
              width: 32,
              height: 32,
              borderRadius: "50%",
              backgroundColor: "#fadcdcff",
              color: "#c22c2cff",
            }}
            title="Delete"
            onClick={() => handleDeleteAudio(row)}
          >
            <i className="bi bi-trash"></i>
          </button>
        </div>
      ),
    }


  ];

  const handleDeleteConfirmAudio = async (id) => {
    try {
      setLoading(true);

      const config = { headers: { Authorization: `Bearer ${token}` } };

      await axios.delete(`/ivr/ivr-audio/delete/?audio_id=${id}`, config);

      await fetchAudios(audioCurrentPage, audioPerPage);

      setSuccessMessage('Audio deleted successfully!');
      setShowSuccessModal(true);

    } catch (error) {
      setErrorMessage(error.response?.data?.message || "Failed to delete audio");
      setShowErrorModal(true);
    } finally {
      setLoading(false);
    }
  }


  function handleDelete(row) {
    ConfirmationAlert(
      `You won't be able to revert this workflow "${row.name}"!`,
      'Yes, delete it!',
      () => handleDeleteConfirmAudio(row.id)
    );
  }

  const columns = [
    {
      name: "ID",
      width: "100px",
      sortable: false,
      cell: (row, index) => index + 1,
    },
    {
      name: "IVR Names",
      selector: (row) => row.ivr_name,
      sortable: true,
    },
    {
      name:'Type',
      selector: (row) => row.greeting_type === 'text' ? 'Text' : 'Speech',
      sortable: true,
    },
    {
      name: "Description",
      selector: (row) => row.ivr_description,
    },
    {
      name: "Actions",
      width: "150px",
      cell: (row) => (
        <div className="d-flex gap-2 justify-content-center">
          {/* Edit */}
          <button
            className="btn btn-sm d-flex align-items-center justify-content-center rounded-circle border border-secondary "
            title="Edit"
            onClick={() =>
              navigate('/create-ivr', {
                state: { editMode: true, ivrID: row.id, company_id: row.id }
              })}
            style={{ width: 34, height: 34, backgroundColor: "#7b99b1ff", color: "#fff" }}
          >
            <i className="bi bi-pencil"></i>
          </button>

          {/* Delete */}
          <button
            className="btn btn-sm d-flex align-items-center justify-content-center rounded-circle border border-secondary "
            title="Delete"
            onClick={() => handleDeleteClick(row)}
            style={{ width: 34, height: 34, backgroundColor: "#ee8080ff", color: "#fff" }}
          >
            <i className="bi bi-trash"></i>
          </button>
        </div>
      ),
    }
  ];



  const customStyles = {
    table: {
      style: {
        backgroundColor: "#1A1C2B",
        color: "#FFFFFF",
      },
    },
    headRow: {
      style: {
        backgroundColor: "#2b3544ff",
        borderBottom: "1px solid rgb(70,79,91)",
        minHeight: "45px",
      },
    },
    headCells: {
      style: {
        color: "#fff",
        fontSize: "14px",
        fontWeight: 600,
        borderRight: "1px solid rgb(70,79,91)",
      },
    },
    rows: {
      style: {
        backgroundColor: "#1A1C2B",
        color: "#fff",
        minHeight: "48px",
        "&:hover": {
          backgroundColor: "#23263A",
        },
      },
    },
    cells: {
      style: {
        borderBottom: "1px solid rgb(70,79,91)",
        fontSize: "14px",
        color: "#E1E1E1",
      },
    },
    pagination: {
      style: {
        backgroundColor: "#1A1C2B",
        color: "#FFFFFF",
        borderTop: "1px solid rgb(70,79,91)",
      },
      pageButtonsStyle: {
        color: "#FFFFFF !important",
        fill: "#FFFFFF !important",
        "&:hover": {
          backgroundColor: "#2A2D3F",
        },
        "&:disabled": {
          color: "#777 !important",
          fill: "#777 !important",
        },
      },
    },

    noData: {
      style: {
        backgroundColor: "transparent",
        color: "#fff",
        padding: "20px",
      },
    },
  };

  const handleSearch = () => {

    console.log('clicked')
  }


  return (
    <div className="container-fluid py-2" >

         <h3 className=" fs-3 fw-bold text-success ">
          {activeTab === 'ivr' ? 'IVR Management' : 'Audio Library'}
        </h3>

      {/* TABS */}
      <div className="d-flex justify-content-center mb-3">
        <div
          className="d-flex align-items-center p-1 rounded-pill"
          style={{
            background: "#0f0f0f",
            border: "1px solid #3f3f3f",
            gap: "4px",
          }}
        >
          <button
            className={`btn rounded-pill px-4 ${activeTab === "ivr" ? "btn-success" : ""
              }`}
            onClick={() => setActiveTab("ivr")}
            disabled={loading}
          >
            <i className="bi bi-diagram-3 me-1"></i> IVR
          </button>

          <button
            className={`btn rounded-pill px-4 ${activeTab === "audio" ? "btn-success" : ""
              }`}
            onClick={() => setActiveTab("audio")}
            disabled={loading}
          >
            <i className="bi bi-soundwave me-1"></i> Audio
          </button>
        </div>
      </div>



      {activeTab === "ivr" &&

        <div className="card border-0 shadow-sm" style={{ backgroundColor: "#0f1220" }}>
           <div className="d-flex align-items-center justify-content-end mb-2 gap-2">
            <div className="row ">

              <div className="col-md-12 d-flex justify-content-end">
                <div
                  style={{ position: "relative", maxWidth: "250px", width: "100%" }}
                >
                  <i
                    className="bi bi-search"
                    style={{
                      position: "absolute",
                      left: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#6c757d",
                      fontSize: "14px",
                    }}
                  ></i>

                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="Search IVR..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    style={{ paddingLeft: "32px" }}
                  />
                </div>

                <Button
                  onClick={handleSearch} className="btn-sm mx-2">Search</Button>
              </div>


            </div>
            <Button
              onClick={() => navigate('/create-ivr')}
              className="btn-sm px-2 btn-success d-flex align-items-center gap-2 fw-semibold"
            >
              <i className="bi bi-telephone-fill"></i>
              Create IVR
            </Button>
          </div> 

          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-success" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <DataTable
              columns={columns}
              data={ivrdata}
              pagination
              customStyles={customStyles}
                paginationServer
                paginationTotalRows={totalCount}
                paginationDefaultPage={currentPage}
                paginationPerPage={perPage}
                onChangeRowsPerPage={handlePerPageChange}
                onChangePage={handlePageChange}
                paginationRowsPerPageOptions={[10, 20, 30, 50]}
            />
          )}
        </div>
      }

      {/* ================= CREATE AUDIO TAB ================= */}
      {activeTab === "audio" && (

        <div className=" ">
          <div className="d-flex gap-2 justify-content-end mb-2 align-items-center">

            <div className="row ">

              <div className="col-md-12 d-flex justify-content-end">
                <div
                  style={{ position: "relative", maxWidth: "250px", width: "100%" }}
                >
                  <i
                    className="bi bi-search"
                    style={{
                      position: "absolute",
                      left: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#6c757d",
                      fontSize: "14px",
                    }}
                  ></i>

                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="Search Audio..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    style={{ paddingLeft: "32px" }}
                  />
                </div>

                <Button
                  onClick={handleSearch} className="btn-sm mx-2">Search</Button>
              </div>


            </div>
            
          <div className="d-flex justify-content-between ">
            <Button
              variant="success btn-sm"
              onClick={() => setShowModal(true)}
            >
              <i className="bi bi-plus-circle me-1"></i>
              Add Audio
            </Button>
          </div>
          </div>

          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-success" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <DataTable
              columns={audioColumns}
              data={audioList}
              customStyles={customStyles}
              pagination
              paginationServer
              paginationTotalRows={audioTotalCount}
              paginationDefaultPage={audioCurrentPage}
              paginationPerPage={audioPerPage}
              onChangeRowsPerPage={handleAudioPerPageChange}
              onChangePage={handleAudioPageChange}
              paginationRowsPerPageOptions={[10, 20, 30, 50]}
            />
          )}

        
        </div>

      )}

      {/* ================= CREATE AUDIO MODAL ================= */}
      <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
          resetAudio();
        }}
        centered
        size="lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-success" >
            <i className="bi bi-mic-fill me-1"></i>
            Create Audio
          </Modal.Title>
        </Modal.Header>

        <Form onSubmit={handleAudioSave}>
          <Modal.Body>
            <div className="row g-3">
              <div className="col-md-6">
                <label className="form-label fw-semibold">
                  Audio Name *
                </label>
                <input
                  className={`form-control ${errorsAudio.audioName ? 'is-invalid' : ''}`}
                  {...registerAudio("audioName", { required: "Audio Name is required" })}
                />
                {errorsAudio.audioName && <div className="invalid-feedback d-block">{errorsAudio.audioName.message}</div>}
              </div>

              <div className="col-md-6">
                <label className="form-label fw-semibold">
                  Language *
                </label>
                <select
                  className={`form-select ${errorsAudio.language ? 'is-invalid' : ''}`}
                  {...registerAudio("language", { required: "Language is required" })}
                >
                  <option value="">Select</option>
                  <option value="en-US">English (USA)</option>
                  <option value="en-IN">English (India)</option>
                  <option value="hi-IN">Hindi (India)</option>
                  <option value="te-IN">Telugu (India)</option>
                  <option value="ta-IN">Tamil (India)</option>
                  <option value="kn-IN">Kannada (India)</option>
                  <option value="ml-IN">Malayalam (India)</option>
                  <option value="mr-IN">Marathi (India)</option>
                  <option value="bn-IN">Bengali (India)</option>
                  <option value="gu-IN">Gujarati (India)</option>
                </select>
                {errorsAudio.language && <div className="invalid-feedback d-block">{errorsAudio.language.message}</div>}
              </div>
                  {/* <div className="col-md-12">
                <label className="form-label fw-semibold">
                  Company *
                </label>
                <select
                  className={`form-select ${errorsAudio.company ? 'is-invalid' : ''}`}
                  {...registerAudio("company", { required: "Company is required" })}
                >
                  <option value="">-- Select Company --</option>
                  {companies.map((comp) => (
                    <option key={comp.id} value={comp.id}>
                      {comp.folder_data?.company_name || comp.folder_name}
                    </option>
                  ))}
                </select>
                {errorsAudio.company && <div className="invalid-feedback d-block">{errorsAudio.company.message}</div>}
              </div> */}

              <div className="col-12">
                <label className="form-label fw-semibold">
                  Text *
                </label>
                <textarea
                  rows={3}
                  className={`form-control ${errorsAudio.description ? 'is-invalid' : ''}`}
                  placeholder="Enter the text to convert to audio"
                  {...registerAudio("description", { required: "Text is required" })}
                />
                {errorsAudio.description && <div className="invalid-feedback d-block">{errorsAudio.description.message}</div>}
              </div>

              <div className="col-md-6">
                <label className="form-label fw-semibold">
                  Voice Gender *
                </label>
                <select
                  className={`form-select ${errorsAudio.gender ? 'is-invalid' : ''}`}
                  {...registerAudio("gender", { required: "Voice Gender is required" })}
                >
                  <option value="">Select</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
                {errorsAudio.gender && <div className="invalid-feedback d-block">{errorsAudio.gender.message}</div>}
              </div>

              <div className="col-md-6">
                <label className="form-label fw-semibold">
                  Voice *
                </label>
                <select
                  className={`form-select ${errorsAudio.voice ? 'is-invalid' : ''}`}
                  disabled={!watchedLanguage || !selectedGender}
                  {...registerAudio("voice", { required: "Voice is required" })}
                >
                  <option value="">
                    {!watchedLanguage || !selectedGender
                      ? "Select Language & Gender First"
                      : "Select Voice"}
                  </option>
                  {voices.map((voice, idx) => (
                    <option key={idx} value={voice.voice_name}>
                      {voice.voice_name}
                    </option>
                  ))}
                </select>
                {errorsAudio.voice && <div className="invalid-feedback d-block">{errorsAudio.voice.message}</div>}
              </div>


            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowModal(false)}
            >
              Cancel
            </Button>
            <Button type="submit" variant="success">
              Save Audio
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>


      {/* SUCCESS MODAL */}
      <Modal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        centered
        backdrop="static"
        contentClassName="border-0 shadow-lg rounded-4"
      >
        <Modal.Body className="p-4 text-center">
          {/* Icon */}
          <div
            className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
            style={{
              width: 80,
              height: 80,
              background: "linear-gradient(135deg, #28a745, #20c997)",
            }}
          >
            <i className="bi bi-check-lg text-white" style={{ fontSize: "2.5rem" }} />
          </div>

          {/* Title */}
          <h5 className="fw-bold mb-2">Success</h5>

          {/* Message */}
          <p className="text-muted mb-4">{successMessage}</p>

          {/* Action */}
          <Button
            variant="success"
            className="px-4 fw-semibold rounded-pill"
            onClick={() => setShowSuccessModal(false)}
          >
            Done
          </Button>
        </Modal.Body>
      </Modal>


      {/* ERROR MODAL */}
      <Modal
        show={showErrorModal}
        onHide={() => setShowErrorModal(false)}
        centered
        backdrop="static"
        contentClassName="border-0 shadow-lg rounded-4"
      >
        <Modal.Body className="p-4 text-center">
          {/* Icon */}
          <div
            className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
            style={{
              width: 80,
              height: 80,
              background: "linear-gradient(135deg, #dc3545, #ff6b6b)",
            }}
          >
            <i className="bi bi-x-lg text-white" style={{ fontSize: "2.2rem" }} />
          </div>

          {/* Title */}
          <h5 className="fw-bold mb-2">Something went wrong</h5>

          {/* Message */}
          <p className="text-muted mb-4">{errorMessage}</p>

          {/* Action */}
          <Button
            variant="outline-danger"
            className="px-4 fw-semibold rounded-pill"
            onClick={() => setShowErrorModal(false)}
          >
            Close
          </Button>
        </Modal.Body>
      </Modal>

    </div>
  );
}
